var color = require('color');
import { TRANSPARENCY_BREAKPOINT } from './constants';
export function isTransparent(value) {
    if (value) {
        try {
            return color(value).alpha() <= TRANSPARENCY_BREAKPOINT;
        }
        catch (error) { }
    }
    return false;
}
export function upgradeColor(value) {
    if (value) {
        if (value === 'transparent') {
            return '#FFFFFF';
        }
        try {
            return color(value).hex();
        }
        catch (error) { }
    }
    return value;
}
export function upgradeColorWithOpacity(value) {
    if (value) {
        if (value === 'transparent') {
            return 'rgba(255, 255, 255, 0)';
        }
        try {
            var parsedValue = color(value);
            if (parsedValue.alpha() <= TRANSPARENCY_BREAKPOINT) {
                return toCssaColor(parsedValue.alpha(0));
            }
            return toCssaColor(parsedValue.alpha(1));
        }
        catch (error) { }
    }
    return value;
}
function toCssaColor(colorToConvert) {
    if (colorToConvert.cssa) {
        return colorToConvert.cssa();
    }
    return colorToConvert.toString();
}
//# sourceMappingURL=upgrade-color.js.map